// ================================
// Header adjustments (法人のみ)
// ================================
function initHeaderAdjustments() {
    const header = document.querySelector('.v2-header-with-announce');
    if (header) {
        header.classList.remove('v2-header-with-announce');
    }
}

// ================================
// fadein animation(contents/title)
// ================================
function initRevealObservers() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const titleElements = document.querySelectorAll('.biz-v2-title-reveal');
    const revealElements = document.querySelectorAll('.biz-v2-reveal');

    // title fadein animation
    titleElements.forEach(elements => {
        const lines = elements.querySelectorAll('.line');
        lines.forEach((element, index) => element.style.setProperty('--i', index));
    });

    if (prefersReducedMotion) {
        titleElements.forEach(element => element.classList.add('is-visible'));
        revealElements.forEach(element => element.classList.add('is-visible'));
        return;
    }

    const titleRevealObserver = new IntersectionObserver((entries, obs) => {
        for (const entry of entries) {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                obs.unobserve(entry.target);
            }
        }
    }, {
        // 要素がほんの少し見えたらアニメーション開始
        threshold: 0.01,
        rootMargin: '0px 0px 30% 0px'
    });

    titleElements.forEach(element => titleRevealObserver.observe(element));

    // contents fadein animation
    const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                revealObserver.unobserve(entry.target);
            }
        });
    }, {
        // 要素がほんの少し見えたらアニメーション開始
        threshold: 0.01,
        rootMargin: '0px 0px 30% 0px'
    });

    revealElements.forEach((element) => revealObserver.observe(element));
}

// ================================
// 下部CTAボタンの表示制御
// ================================
function initBottomCtaVisibility() {
    const bottomCta = document.querySelector('.biz-v2__hero-bottom-cta');
    if (!bottomCta) return;

    const footer = document.querySelector('footer');
    let isScrolled = false;
    let isFooterVisible = false;
    let ctaTicking = false;

    function updateVisibility() {
        if (isScrolled && !isFooterVisible) {
            bottomCta.classList.add('is-visible');
        } else {
            bottomCta.classList.remove('is-visible');
        }
    }

    // スクロール閾値チェック（pageYOffset はレイアウト強制しない）
    function onScroll() {
        if (ctaTicking) return;
        ctaTicking = true;
        window.requestAnimationFrame(() => {
            ctaTicking = false;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const wasScrolled = isScrolled;
            isScrolled = scrollTop > 100;
            if (wasScrolled !== isScrolled) updateVisibility();
        });
    }

    // フッター可視判定を IntersectionObserver に置換（getBoundingClientRect 廃止）
    if (footer) {
        const footerObserver = new IntersectionObserver((entries) => {
            const wasFooterVisible = isFooterVisible;
            isFooterVisible = entries[0].isIntersecting;
            if (wasFooterVisible !== isFooterVisible) updateVisibility();
        }, { threshold: 0 });
        footerObserver.observe(footer);
    }

    // 初期状態
    isScrolled = (window.pageYOffset || document.documentElement.scrollTop) > 100;
    updateVisibility();

    window.addEventListener('scroll', onScroll, { passive: true });
}

// ================================
// 読み込み後に実行
// ================================
// ================================
// ヒーロー動画: viewport と prefers-reduced-motion で source を再選択
// ================================
function initHeroVideoLoading() {
    const mq = window.matchMedia('(min-width: 769px) and (prefers-reduced-motion: no-preference)');
    const video = document.querySelector('[data-biz-v2-hero-video="true"]');
    if (!video) return;

    function apply(isInitial) {
        if (isInitial) {
            if (!mq.matches) video.pause();
            return;
        }

        video.pause();
        video.load();

        if (!mq.matches) return;

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
        }
    }

    apply(true);
    mq.addEventListener('change', () => apply(false));
}

// ================================
// About Prairie Card card motion
// ================================
function initAboutPrairieCardMotion() {
    const pinSections = document.querySelectorAll('[data-biz-v2-about-pin]');
    pinSections.forEach(section => {
        const card = section.querySelector('[data-biz-v2-about-card]');
        const phoneBase = section.querySelector('[data-biz-v2-about-phone-base]');
        const phoneAlt = section.querySelector('[data-biz-v2-about-phone-alt]');
        if (!card || !phoneBase || !phoneAlt) return;

        function getProgress() {
            const rect = section.getBoundingClientRect();
            const total = section.offsetHeight - window.innerHeight;
            const scrolled = Math.min(Math.max(-rect.top, 0), total);
            const progress = total > 0 ? scrolled / total : 0;

            return Math.min(progress / 0.6, 1);
        }

        function computeMotion() {
            const overlap = Math.min(card.offsetHeight, phoneBase.offsetHeight) * 0.5;
            const endY = phoneBase.offsetTop - card.offsetTop - card.offsetHeight + overlap;
            return { startY: 0, endY };
        }

        let cached = { startY: 0, endY: 0 };
        let ticking = false;

        function update() {
            ticking = false;
            if (!section.offsetHeight) return;
            const p = getProgress();
            const { startY, endY } = cached;
            const y = startY + (endY - startY) * p;
            card.style.transform = `translate3d(0, ${y}px, 0)`;

            if (p >= 1) {
                phoneAlt.classList.add('is-visible');
                phoneBase.classList.add('is-hidden');
            } else {
                phoneAlt.classList.remove('is-visible');
                phoneBase.classList.remove('is-hidden');
            }
        }

        function onScroll() {
            if (!ticking) {
                window.requestAnimationFrame(update);
                ticking = true;
            }
        }

        function onResize() {
            if (!section.offsetHeight) return;
            cached = computeMotion();
            update();
        }

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onResize);
        window.addEventListener('load', onResize);
        [phoneBase, phoneAlt].forEach(img => img.addEventListener('load', onResize));
        onResize();
    });
}

// ================================
// Case study list expansion
// ================================
function initCaseStudyExpansion() {
    const showAll = document.querySelectorAll('.show-all');
    showAll.forEach((element) => {
        element.addEventListener('click', () => {
            const controlledListId = element.getAttribute('aria-controls');
            const sectionItems = controlledListId
                ? document.getElementById(controlledListId)
                : element.closest('.v2-all-blog__section-items');
            if (!sectionItems) return;

            sectionItems.classList.remove('show-only-two-child');
            element.setAttribute('aria-expanded', 'true');
            element.style.setProperty('display', 'none', 'important');

            // ボタンが消えてフォーカスを失わないよう、新たに表示された3件目へ移す
            const firstRevealedLink = typeof sectionItems.querySelector === 'function'
                ? sectionItems.querySelector(':scope > :nth-child(3) a')
                : null;
            if (firstRevealedLink && typeof firstRevealedLink.focus === 'function') {
                firstRevealedLink.focus({ preventScroll: true });
            }
        });
    });

    const showMoreScrolls = document.querySelectorAll('.v2-all-blog__more-scroll');
    showMoreScrolls.forEach((showMoreScroll) => {
        showMoreScroll.addEventListener('click', () => {
            const sectionItems = showMoreScroll.parentElement.querySelector('.v2-all-blog__section-items');
            if (sectionItems) {
                sectionItems.scrollBy({
                    left: 300,
                    behavior: 'smooth',
                });
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initHeaderAdjustments();
    initRevealObservers();
    initBottomCtaVisibility();
    initHeroVideoLoading();
    initAboutPrairieCardMotion();
    initCaseStudyExpansion();
});




/*
  ピン留め切替
  - .biz-v2__hoge-pin-section の高さ = (step数 × 100vh)
  - 内部の .biz-v2__pin を position: sticky; top:0 にして「画面固定」
  - スクロール量からセクション内の進捗を 0～1 で計算し、どの Area を出すか決定
*/

{/* 
  <div class="biz-v2__js-pin">
    <div class="area">エリア1の内容</div>
    <div class="area">エリア2の内容</div>
    <div class="area">エリア3の内容</div>
    
    <div class="indicator-dot"></div>
    <div class="indicator-dot"></div>
    <div class="indicator-dot"></div>
    
    <div class="area-label">ラベル1</div>
    <div class="area-label">ラベル2</div>
    <div class="area-label">ラベル3</div>
    
    <button class="swipe-button--prev">前へ</button>
    <button class="swipe-button--next">次へ</button>
  </div> 
*/}

(function () {
    const sections = document.querySelectorAll('.biz-v2__js-pin');

    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

    function setupSection(section) {
        const areas = Array.from(section.querySelectorAll('.biz-v2__area'));
        section.style.setProperty('--steps', areas.length);
        // ステップ切替（現在のインデックスだけ .is-active）
        let current = -1;
        let isProgrammaticScroll = false;

        // レイアウト値キャッシュ（scrollイベント内でのDOM読み取りを回避）
        let cachedStart = section.offsetTop;
        let cachedEnd = cachedStart + section.offsetHeight - window.innerHeight;

        function recacheLayout() {
            cachedStart = section.offsetTop;
            cachedEnd = cachedStart + section.offsetHeight - window.innerHeight;
        }

        // 画像遅延読込・フォント適用後のサイズ変化を監視
        // bodyを監視: セクションより上のコンテンツの高さ変化でoffsetTopがズレるケースも拾う
        const ro = new ResizeObserver(recacheLayout);
        ro.observe(document.body);

        function scrollToStep(index) {
            recacheLayout(); // クリック時は最新値を使う
            const steps = areas.length;
            const targetProgress = (index + 0.5) / steps; // 各Areaの中央へ
            const targetScrollY = cachedStart + (cachedEnd - cachedStart) * targetProgress;
            isProgrammaticScroll = true;
            window.scrollTo({ top: targetScrollY, behavior: 'smooth' });
            // 一定時間後にスクロール同期フラグを解除
            setTimeout(() => { isProgrammaticScroll = false; }, 500);
        }
        function setActive(idx) {
            if (idx === current) return;
            current = idx;
            areas.forEach((el, i) => {
                el.classList.toggle('is-active', i === idx);

            });

            // Areaインジケーターの更新
            const indicatorDots = section.querySelectorAll('.indicator-dot');
            const areaLabels = section.querySelectorAll('.area-label');

            indicatorDots.forEach((dot, i) => {
                dot.classList.toggle('active', i === idx);
            });

            areaLabels.forEach((label, i) => {
                label.classList.toggle('active', i === idx);
            });

            updateSwipeButtons();
        }

        // スワイプボタンの制御
        function updateSwipeButtons() {
            const prevButton = section.querySelector('.swipe-button--prev');
            const nextButton = section.querySelector('.swipe-button--next');

            if (prevButton && nextButton) {
                prevButton.classList.toggle('hidden', current === 0);
                nextButton.classList.toggle('hidden', current === areas.length - 1);
            }
        }

        // スワイプボタンのイベントリスナー
        function setupSwipeButtons() {
            const prevButton = section.querySelector('.swipe-button--prev');
            const nextButton = section.querySelector('.swipe-button--next');

            if (prevButton) {
                prevButton.addEventListener('click', () => {
                    if (current > 0) {
                        const target = current - 1;
                        setActive(target);
                        scrollToStep(target);
                    }
                });
            }

            if (nextButton) {
                nextButton.addEventListener('click', () => {
                    if (current < areas.length - 1) {
                        const target = current + 1;
                        setActive(target);
                        scrollToStep(target);
                    }
                });
            }
        }

        // Areaインジケーターのテキストクリック機能（PCのみ）
        function setupAreaLabels() {
            const areaLabels = section.querySelectorAll('.area-label');

            areaLabels.forEach((label, index) => {
                label.addEventListener('click', () => {
                    // PCサイズでのみ有効
                    if (window.innerWidth >= 900) {
                        setActive(index);
                        recacheLayout(); // クリック時は最新値を使う
                        const totalSteps = areas.length;

                        // クリックしたAreaに対応するスクロール位置を計算
                        const targetProgress = (index + 0.5) / totalSteps; // 各Areaの中央位置
                        const targetScrollY = cachedStart + (cachedEnd - cachedStart) * targetProgress;

                        // スムーズスクロールで移動
                        window.scrollTo({
                            top: targetScrollY,
                            behavior: 'smooth'
                        });
                    }
                });
            });
        }

        function onScroll() {
            if (isProgrammaticScroll) return; // 同期スクロール中は無視
            const y = window.scrollY; // scrollY はレイアウト強制しない

            const progress = clamp((y - cachedStart) / Math.max(1, (cachedEnd - cachedStart)), 0, 1);
            const steps = areas.length;
            const idx = Math.min(steps - 1, Math.floor(progress * steps));
            setActive(idx);
        }

        // 初期表示・イベント
        onScroll();
        setupSwipeButtons();
        setupAreaLabels();
        return { onScroll, recacheLayout };
    }

    const handlers = Array.from(sections).map(setupSection);

    // rAF gate: スクロールハンドラを1フレームに1回に制限
    let pinTicking = false;
    function onPinScroll() {
        if (pinTicking) return;
        pinTicking = true;
        window.requestAnimationFrame(() => {
            handlers.forEach(h => h.onScroll());
            pinTicking = false;
        });
    }

    window.addEventListener('scroll', onPinScroll, { passive: true });
    window.addEventListener('resize', () => {
        handlers.forEach(h => { h.recacheLayout(); h.onScroll(); });
    });

    // ページ内リンク等での位置ジャンプ対策（描画後にも一度）
    window.requestAnimationFrame(() => { handlers.forEach(h => h.onScroll()); });
})();
